import { ClientsService } from '@services/client/clients.service';
import { EmployeesService } from '@services/employees/employees.service';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription, Observable } from 'rxjs';
import { StorageService } from '@services/services.module';
import { startWith, map } from 'rxjs/operators';
import { UtilsService } from '@services/utils/utils.service';
import { ProjectsService } from '@services/projects/projects.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'search-input-dynamic',
  templateUrl: './search-input-dynamic.component.html',
  styleUrls: ['./search-input-dynamic.component.scss']
})
export class SearchInputDynamicComponent implements OnInit, OnDestroy, OnChanges {
  @Input() typeList = '';
  @Input() value = '';
  @Input() externalSelected = '';
  @Input() required = false;
  @Input() placeholder = '';
  @Input() showLabel = true;
  @Input() clearEvent: Observable<void>;
  @Output() clean: EventEmitter<any> = new EventEmitter();
  @Output() eventId: EventEmitter<any> = new EventEmitter();

  private subscriptions: Array<Subscription> = [];
  private list: any = [];
  private projectList: any = [];
  private employeList: any = [];
  private listAllClients: any = [];
  private listAllDivisions: any [];
  public myControl = new FormControl();
  public filteredOptions: Observable<any[]>;
  public userData: any;
  public enableInput = false;
  public selectedObject;
  public hideLabel = '';

  constructor(
    private storage: StorageService,
    private utilsService: UtilsService,
    private employeesService: EmployeesService,
    private clientsService: ClientsService,
    private projectsService: ProjectsService
  ) { }

  ngOnInit() {
    this.userData = this.storage.get('userDataStorage');
    this.getList();
    this.hideLabel = this.showLabel === false ? 'never' : '';
  }

  ngOnChanges() {
    if (this.externalSelected && this.externalSelected !== '') {
      if (this.typeList === 'listAllClients') {
        this.value = this.list.filter(client => client.Id === this.externalSelected)[0].campoCompleto;
        this.onChange();
      }
    }
  }

  getList() {
    if (this.typeList === 'listEmployee') {
      if (this.storage.get('listEmployee')) {
        this.list = this.storage.get('listEmployee')
          .sort(this.utilsService.compareItemByFullField);
        this.filteredOptions = this.myControl.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filter(value))
          );
      } else {
        this.subscriptions.push(
          this.employeesService.getAllEmployees().subscribe(data => {
            if (data.length) {
              this.employeList = data;
              this.employeList.sort(this.utilsService.compareEmployeeByName);
              this.employeList.map((item) => {
                item.campoCompleto = item.nameEmployee + ' ' + item.surnamesEmployee;
                item.Id = item.employeeId;
                return item;
              });
              this.storage.set('listEmployee', this.employeList);

              this.list = this.storage.get('listEmployee');
              this.filteredOptions = this.myControl.valueChanges
                .pipe(
                  startWith(''),
                  map(value => this._filter(value))
                );
            }
          })
        );
      }
    }

    if (this.typeList === 'listProjectsByEmployee') {
      if (this.storage.get('listProjectsByEmployee')) {
        this.list = this.storage.get('listProjectsByEmployee')
          .sort(this.utilsService.compareItemByFullField);
        this.filteredOptions = this.myControl.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filter(value))
          );
      } else {
        this.subscriptions.push(
          this.projectsService.getProjects(this.userData.employeeNumber).subscribe((proyectData) => {
            if (proyectData) {
              proyectData.sort(this.utilsService.compareProjectByDescription);
              proyectData.map((item) => {
                item.campoCompleto = item.sapId + ' ' + item.description;
                item.Id = item.projectId;
                return item;
              });
              this.storage.set('listProjectsByEmployee', proyectData);

              this.list = this.storage.get('listProjectsByEmployee');
              this.filteredOptions = this.myControl.valueChanges
                .pipe(
                  startWith(''),
                  map(value => this._filter(value))
                );
            }
          })
        );
      }
    }

    if (this.typeList === 'listAllprojects') {
      if (this.storage.get('listAllprojects')) {
        this.list = this.storage.get('listAllprojects');
        this.filteredOptions = this.myControl.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filter(value))
          );
      } else {
        this.subscriptions.push(
          this.projectsService.getAllProjects().subscribe((proyectData) => {
            if (proyectData.length) {
              this.projectList = proyectData;
              this.projectList.sort((a, b) => {
                if (a.varProDescripcion < b.varProSapId) { return -1; }
                if (a.varProDescripcion > b.varProSapId) { return 1; }
                return 0;
              });
              this.projectList.map((item) => {
                item.campoCompleto = item.varProSapId + ' ' + item.varProDescripcion;
                item.Id = item.intProId;
                return item;
              });
              this.storage.set('listAllprojects', this.projectList);
              this.list = this.storage.get('listAllprojects');
              this.filteredOptions = this.myControl.valueChanges
                .pipe(
                  startWith(''),
                  map(value => this._filter(value))
                );

            }
          })
        );
      }
    }

    if (this.typeList === 'listAllClients') {
      if (this.storage.get('listAllClients')) {
        this.list = this.storage.get('listAllClients')
          .sort(this.utilsService.compareItemByFullField);
        this.filteredOptions = this.myControl.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filter(value))
          );
      } else {
        this.subscriptions.push(
          this.clientsService.getAllClients().subscribe(data => {
            if (data) {
              this.listAllClients = data;
              this.listAllClients.sort(this.utilsService.compareClientByName);
              if (!this.storage.get('listAllClients')) {
                this.listAllClients.map((item) => {
                  item.campoCompleto = item.nameClient;
                  item.Id = item.clientId;
                  return item;
                });
                this.storage.set('listAllClients', this.listAllClients);
                this.list = this.storage.get('listAllClients');
                this.filteredOptions = this.myControl.valueChanges
                  .pipe(
                    startWith(''),
                    map(value => this._filter(value))
                  );
              }
            }
          })
        );
      }
    }

    if (this.typeList === 'listDivisions') {
      if (this.storage.get('divisions')) {
        this.list = this.storage.get('divisions');
        this.filteredOptions = this.myControl.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filter(value))
          );
      } else {
        this.subscriptions.push(
          this.projectsService.getDivisions().subscribe(data => {
            if (data) {

              this.listAllDivisions = data;

              if (!this.storage.get('divisions')) {
                this.listAllDivisions.sort((a, b) => {
                  if (a.varDivDescripcion < b.varDivDescripcion) {
                    return -1;
                  }

                  if (a.varDivDescripcion > b.varDivDescripcion) {
                    return 1;
                  }

                  return 0;
                });

                this.listAllDivisions.map((item) => {
                  item.campoCompleto = `${item.varDivDescripcion} - ${item.varDivCodigo}`;
                  item.Id = item.intDivId;
                  return item;
                });

                this.storage.set('divisions', this.listAllDivisions);

                this.list = this.storage.get('divisions');
                this.filteredOptions = this.myControl.valueChanges
                  .pipe(
                    startWith(''),
                    map(value => this._filter(value))
                  );
              }
            }
          })
        );
      }
    }
  }

  private _filter(value: string): string[] {
    if (this.list) {
      const filterValue = this.utilsService.cleanString(value).toLowerCase();
      return this.list.filter(item => this.utilsService.cleanString(item.campoCompleto).toLowerCase().includes(filterValue));
    }
  }

  // recoger el proyecto seleccionado SapId
  onChange() {
    if (this.value) {
      const valueId = this.value;
      if (valueId) {

        if (this.list) {
          // si le llega desde input 1300-0000-23
          if (this.list.find(m => m.sapId === valueId)) {
            this.selectedObject = this.list.find(m => m.sapId === valueId);
            this.value = '';
            this.value = this.selectedObject.campoCompleto;
          } else // si le llega el proyecto completo
            if (this.list.find(m => m.campoCompleto === valueId)) {
              this.selectedObject = this.list.find(m => m.campoCompleto === valueId);
              if (this.typeList === 'listProjectsByEmployee') {
                this.eventId.emit(
                  {
                    Id: this.selectedObject.projectId,
                    name: this.selectedObject.sapId
                  }
                );
              } else if (this.typeList === 'listAllprojects') {
                this.eventId.emit(
                  {
                    Id: this.selectedObject.intProId,
                    name: this.selectedObject.varProDescripcion
                  }
                );
              } else if (this.typeList === 'listAllClients') {
                this.eventId.emit(
                  this.selectedObject
                );
              } else  if (this.typeList === 'listDivisions') {
                this.eventId.emit({ id: this.selectedObject.Id, name: this.selectedObject.campoCompleto });
              } else {
                this.eventId.emit({ Id: this.selectedObject.Id, name: this.selectedObject.campoCompleto });
              }
              this.enableInput = true;
            }
        }
      }
    }
  }

  clear(event: any) {
    event.preventDefault();
    this.value = '';
    this.externalSelected = '';
    this.enableInput = false;
    this.clean.emit();
  }

  ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }

}
